export default "__VITE_ASSET__1PuhQ8tU__"